import { ServiceResult } from '../models';
import { DeleteRecipeMenuDetailRequest, UpdateRecipeMenuDetailsRequest } from '../models/recipe-menu-detail.models';

import ApiService from './api-service';

class RecipeMenuDetailService extends ApiService {
  private static classInstance: RecipeMenuDetailService;

  private constructor() {
    super('RecipeMenuDetail');
  }

  public static getInstance(): RecipeMenuDetailService {
    if (!this.classInstance) {
      this.classInstance = new RecipeMenuDetailService();
    }
    return this.classInstance;
  }
  public updateRecipeMenuDetails(request: UpdateRecipeMenuDetailsRequest): ServiceResult<void> {
    return this.post(`${this.baseUrl}/UpdateRecipeMenuDetails`, request);
  }
  public deleteRecipeMenuDetail(request: DeleteRecipeMenuDetailRequest): ServiceResult<void> {
    return this.post(`${this.baseUrl}/DeleteRecipeMenuDetail`, request);
  }
}

export default RecipeMenuDetailService;
